import { ReactElement, useState } from "react";
import { MapTheme, mapThemes } from "../../../../services/map/config/map-themes";
import { className } from "../../../../shared/helpers";
import styles from "./ThemeSelector.module.scss";

interface ThemeSelectorProps
{
    selectTheme: (e: Event) => void;
}

const ThemeSelector = (props: ThemeSelectorProps): ReactElement =>
{
    const [togglerVisible, setTogglerVisibility] = useState<boolean>(false);

    return (
        <div {...className(styles.themeSelector, { [styles.isHidden]: !togglerVisible })}>
            <button
                className={styles.themeSelectorToggler}
                onClick={() => setTogglerVisibility(!togglerVisible)}
            >
                {togglerVisible ? "Hide" : "Show"} theme selector
            </button>

            {mapThemes.map((theme: MapTheme) => (
                <button
                    key={theme.id}
                    value={theme.value}
                    className={styles.themeButton}
                    style={{ backgroundImage: `url(${theme.icon})` }}
                    onClick={(e: any) => props.selectTheme(e)}
                />
            ))}
        </div>
    );
};

export default ThemeSelector;
